export const objectDotNotationGetter = (obj, is, value) => {
  if (typeof obj === 'undefined') return undefined;
  if (typeof is === 'string') return objectDotNotationGetter(obj, is.split('.'), value);
  if (is.length === 1 && typeof value !== 'undefined') return obj[is[0]] = value;
  if (is.length === 0) return obj;
  return objectDotNotationGetter(obj[is[0]], is.slice(1), value);
};
